export const AchFeesFields = {
	SetupFee: {
		name: "achSetupFee",
		displayName: "Setup Fee",
		beName: "achSetupFee",
	},
	MonthlyFee: {
		name: "achMonthlyFee",
		displayName: "Monthly Fee",
		beName: "achMonthlyFee",
	},
	TransactionFee: {
		name: "achTransactionFee",
		displayName: "Transaction Fee",
		beName: "achTransactionFee",
	},
	OriginationDiscountFee: {
		name: "achOriginationDiscountFee",
		displayName: "Origination Discount Fee",
		beName: "achOriginationDiscountFee",
	},
	OriginationLargeTransactionDiscountFee: {
		name: "achOriginationLargeTransactionDiscountFee",
		displayName: "Origination Large Transaction Discount Fee",
		beName: "achOriginationLargeTransactionDiscountFee",
	},
	StandardReturnFee: {
		name: "achStandardReturnFee",
		displayName: "Standard Return Fee",
		beName: "achStandardReturnFee",
	},
	NoticeOfChangeReturnFee: {
		name: "achNoticeOfChangeReturnFee",
		displayName: "Notice Of Change Return Fee",
		beName: "achNoticeOfChangeReturnFee",
	},
	ChargebackReturnFee: {
		name: "achChargebackReturnFee",
		displayName: "Chargeback Return Fee",
		beName: "achChargebackReturnFee",
	},
	AccountVerificationFee: {
		name: "achAccountVerificationFee",
		displayName: "Account Verification Fee",
		beName: "achAccountVerificationFee",
	},
	AccountVerificationPlusFee: {
		name: "achAccountVerificationPlusFee",
		displayName: "Account Verification Plus Fee",
		beName: "achAccountVerificationPlusFee",
	},
};
